import { createSlice } from '@reduxjs/toolkit';
import { ISelectedLocation } from 'shared/createCard/types/cianCard';

const initialState: ISelectedLocation[] = [];

/* istanbul ignore next */
const regionsSlice = createSlice({
  initialState,
  name: 'regions',
  reducers: {},
});

export const { reducer: regionsSliceReducer } = regionsSlice;
